<div [class]="isTopAligned ? 'not-centered bg' : 'bg'">
    <div class="loader"></div>
</div>
